<div
    class="workflow-container container d-flex flex-column align-items-center"
    (click)="containerClick()"
>
    @if (!workflowNodes.length) {
        <div
            class="workflow-node-wrapper d-flex flex-column align-items-center w-100"
        >
            <div
                (click)="onAddClick()"
                wdxStopPropagation
                class="workflow-node card card-clickable add-placeholder text-muted text-center"
                [class.active]="activeNodeId === 'root'"
            >
                + {{ 'WORKFLOW_ADD_NODE' | translateTokenisedString }}
            </div>
        </div>
    } @else {
        @for (node of workflowNodes; track node.payload.Id) {
            <ng-container
                *ngTemplateOutlet="renderNode; context: { $implicit: node }"
            />
        }
    }
</div>

<ng-template #renderNode let-node>
    <div
        class="workflow-node-wrapper d-flex flex-column align-items-center w-100"
    >
        <div
            (click)="onNodeClick(node)"
            wdxStopPropagation
            class="workflow-node card card-clickable overflow-hidden"
            [class.active]="
                activeNodeId ===
                buildActiveNodeId(node.payload.Id, node.logicCode)
            "
        >
            <div class="card-body d-flex align-items-center">
                <div class="d-flex align-items-center flex-shrink-0 me-1 ms-1">
                    <wdx-icon
                        scale="1.5"
                        severity="info"
                        [icon]="node.icon"
                        class="me-2"
                    ></wdx-icon>
                </div>
                <div class="flex-grow-1 overflow-hidden">
                    <h5 class="text-primary">
                        {{ node.name.key | translateTokenisedString }}
                    </h5>
                    <p>{{ node.description.key | translateTokenisedString }}</p>
                </div>
                <ng-container
                    *ngTemplateOutlet="
                        dropdownTemplate;
                        context: { $implicit: node }
                    "
                ></ng-container>
            </div>
            <div class="card-footer">
                <div class="d-flex">
                    <div class="ms-auto">
                        <wdx-badge
                            [themeColor]="node.isValid ? 'success' : 'danger'"
                        >
                            <wdx-icon [icon]="node.isValid ? 'check' : 'xmark'">
                            </wdx-icon>
                        </wdx-badge>
                    </div>
                </div>
            </div>
        </div>

        @if (hasChildNodes(node.children)) {
            <ng-container
                *ngTemplateOutlet="
                    renderLogicNode;
                    context: { $implicit: node }
                "
            />
        } @else {
            <ng-container
                *ngTemplateOutlet="
                    renderConnector;
                    context: { $implicit: node }
                "
            />
        }
    </div>
</ng-template>

<ng-template #renderConnector let-node>
    <div class="workflow-connector position-relative mx-auto">
        <div class="workflow-line"></div>
        <button
            class="workflow-add-btn position-absolute top-50 start-50 translate-middle"
            wdxIconButton
            type="button"
            (click)="onAddClick(node)"
            wdxStopPropagation
        >
            <wdx-icon icon="plus" size="sm" />
        </button>
    </div>
</ng-template>

<ng-template #renderLogicNode let-node>
    <div
        class="workflow-condition-wrapper border border-2 rounded p-3 mt-4 w-100 position-relative"
    >
        <div
            class="workflow-condition-logic-steps d-flex justify-content-between gap-3 w-100"
        >
            @for (
                entry of node.children
                    | keyvalueOrder: node.childLogicCodesOrder;
                track entry.key
            ) {
                <div
                    class="workflow-logic-container flex-fill position-relative border border-1 rounded p-2"
                >
                    <div
                        class="logic-label px-2 py-1 text-white rounded small mb-2"
                        [ngClass]="getLogicColour(entry.key)"
                    >
                        {{ `WORKFLOW_LOGIC_${entry.key.toUpperCase()}` | translateTokenisedString }}
                    </div>
                    @if (entry.value?.length > 0) {
                        @for (child of entry.value; track child.payload.Id) {
                            <ng-container
                                *ngTemplateOutlet="
                                    renderNode;
                                    context: { $implicit: child }
                                "
                            />
                        }
                    } @else {
                        <div
                            class="workflow-node-wrapper d-flex flex-column align-items-center w-100"
                        >
                            <div
                                (click)="onAddClick(node, entry.key, true)"
                                wdxStopPropagation
                                class="workflow-node card card-clickable add-placeholder text-muted text-center"
                                [class.active]="
                                    activeNodeId ===
                                    buildActiveNodeId(
                                        node.payload.Id,
                                        entry.key,
                                        true
                                    )
                                "
                            >
                                +
                                {{
                                    'WORKFLOW_ADD_NODE'
                                        | translateTokenisedString
                                }}
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
    <ng-container
        *ngTemplateOutlet="renderConnector; context: { $implicit: node }"
    />
</ng-template>

<ng-template #dropdownTemplate let-node>
    <wdx-dropdown
        ngbDropdown
        container="body"
        wdxStopPropagation
        (openChange)="openChange($event)"
    >
        <button
            class="px-2 py-1 ms-1"
            type="button"
            wdxIconButton
            [wdxButtonSize]="WdxButtonSize.Sm"
            ngbDropdownToggle
        >
            <wdx-icon iconStyle="fas" icon="ellipsis-h"></wdx-icon>
        </button>
        <wdx-dropdown-menu ngbDropdownMenu>
            @if (opened) {
                @for (action of actions; track $index) {
                    <button
                        [disabled]="action.isDisabled(node)"
                        type="button"
                        class="d-flex"
                        ngbDropdownItem
                        (click)="actionClicked(action, node)"
                        wdxStopPropagation
                    >
                        @if (action.icon) {
                            <wdx-icon
                                [icon]="action.icon"
                                class="me-1"
                            ></wdx-icon>
                        } @else {
                            <div class="m-1 ps-1"></div>
                        }
                        {{ action?.displayName.key | translateTokenisedString }}
                    </button>
                }
            }
        </wdx-dropdown-menu>
    </wdx-dropdown>
</ng-template>
